
















import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect,
    },

    data: function () {
        return {
            pathInStore: "property.land.sewerConnection",
        };
    },

    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL", "LAND", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        sewerConnection: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("undefined"),
                    "value": ""
                },
                {
                    "label": this.$t("sewer_connected"),
                    "value": "CONNECTED"
                },
                {
                    "label": this.$t("sewer_not_connected"),
                    "value": "NOT_CONNECTED"
                },
                {
                    "label": this.$t("sewer_can_be_connected"),
                    "value": "CAN_BE_CONNECTED"
                },
                {
                    "label": this.$t("sewer_cannot_be_connected"),
                    "value": "CANNOT_BE_CONNECTED"
                }
            ];
        }
    },

    methods: {
        updateValue: function(sewerConnectionValue: string): void {
            if (sewerConnectionValue === "") {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": sewerConnectionValue});
            }
        },
    },
});
